import BookingInfo from "./BookingInfo";

export default BookingInfo;
